<template>
  <button
    id="ast-scroll-top"
    tabindex="0"
    class="bg-[#FF0000] flex fixed bottom-6 right-6 p-2 z-20"
    @click="scrollToTop"
  >
    <svg
      class="invert rotate-180 h-4 w-4"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      version="1.1"
      x="0px"
      y="0px"
      width="26px"
      height="16.043px"
      viewBox="57 35.171 26 16.043"
      enable-background="new 57 35.171 26 16.043"
      xml:space="preserve"
    >
      <path
        d="M57.5,38.193l12.5,12.5l12.5-12.5l-2.5-2.5l-10,10l-10-10L57.5,38.193z"
      />
    </svg>
  </button>
</template>

<script>
export default {
  name: 'ScrollTop',
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
  },
};
</script>

<style scoped></style>
